module.exports = __webpack_public_path__ + "img/banner-serve.02d59963.png";